import { connect } from 'react-redux';
import RolesTab from '../../components/Modals/MeetingsModal/Tabs/RolesTab';
import { Global } from '../../state/Global';
import { currentUserSelectors } from '@lifesize/nucleus';

const mapStateToProps = (state: Global, ownProps: object) => ({
  ...ownProps,
  currentUser: currentUserSelectors.myInfo(state)
});

export const RolesTabContainer = connect(mapStateToProps)(RolesTab);
